import {setPageConfig,setNowTabPageCongfig,clearRowDataDeep,getMyColums} from "@/tools/table-drag.js";
let cacheSize = parseInt(localStorage.getItem('pageSize'));
import {getRandomString,isNotEmpty} from "@/tools/utils";
const tableData = {};
const pageConfig = {
    loading:false,
    updateErpMaterialLaoding:false,
    updateErpMaterialMsg:[],
    tableName:'material-comp',
    height:'',
    pageKey:getRandomString(),
    top_tools:{
        "ITEM":[
            // { index: 0, name: ['新增物料默认配置'], icon: 'fas fa-plus', check_lines: 0, on_click: [], sign: 'handleAdd', },
            { index: 1, name: ['手动更新ERP'], icon: 'fas fa-sync-alt', check_lines: 0, on_click: [], sign: 'updateErpMaterial', },
            // { index: 2, name: ['合并历史数据'], icon: 'fas fa-code-branch', check_lines: 0, on_click: [], sign: 'handleMerge', },
            // { index: 3, name: ['手动接收'], icon: 'fas fa-hand-paper', check_lines: 0, on_click: [], sign: 'handleGet', },
            { index: 4, name: ['导出'], icon: 'fas fa-file-excel', check_lines: 0, on_click: [], sign: 'exportExcel', },
        ]
    },
    pageConfig:{},
    pageConfigTree:[],
}
const state = () => ({
    materialComp: Object.assign({}, tableData,pageConfig),
})
const getters = {
    getPageConfig: state => state.materialComp.pageConfig,
    getPageConfigTree: state => state.materialComp.pageConfigTree,
    getPageKey:state => state.materialComp.pageKey,
    getUpdateErpMaterialMsg:state => state.materialComp.updateErpMaterialMsg,
    getUpdateErpMaterialLaoding:state => state.materialComp.updateErpMaterialLaoding,
}
const mutations ={
    setRestPageFun(state, data){
        state.materialComp.resetPage = data;
    },
    setLoading(state, data){
        state.materialComp.loading = data;
        if(isNotEmpty(state.materialComp.pageConfig)){
            Object.keys(state.materialComp.pageConfig).forEach((key,index)=>{
                state.materialComp.pageConfig[key].loading = data;
            })
        }
    },
    setPageConfig(state, data){
        state.materialComp.pageConfig = data.pageConfig;
        state.materialComp.pageConfigTree = data.allArrData;
        state.materialComp.pageKey = getRandomString();
        if(isNotEmpty(state.materialComp.pageConfig)){
            Object.keys(state.materialComp.pageConfig).forEach((key,index)=>{
                state.materialComp.pageConfig[key].height = state.materialComp.height
            })
        }
    },
    setList(state, data) {
        state.materialComp.pageConfig[data.obj].data = data.data;
        state.materialComp.pageConfig[data.obj].pagination.rowsNumber = data.count;
    },
    ['refreshTableHeight'](state, data) {
        state.materialComp.height = (data+10) + 'px';
        if(isNotEmpty(state.materialComp.pageConfig)){
            Object.keys(state.materialComp.pageConfig).forEach((key,index)=>{
                state.materialComp.pageConfig[key].height = state.materialComp.height;
            })
        }
    },
    ['clearData'](state, data) {
        clearRowDataDeep({tabName:data.tabName,pageConfig:state.materialComp.pageConfig,pageConfigTree:state.materialComp.pageConfigTree});
    }
}
const actions = {
    ['return_update_client__erp_material']({ state, commit,dispatch }, payload) {
        
        if (payload.success && isNotEmpty(payload.msg)) {
            state.materialComp.updateErpMaterialLaoding = true;
            state.materialComp.updateErpMaterialMsg.unshift(payload.msg);
        }
        if (payload.success && payload.done) {
            state.materialComp.updateErpMaterialLaoding = false;
            state?.materialComp?.resetPage({});
        }
    },
    ['update_client__erp_material']({ state, dispatch, rootState ,commit}, payload) {
        if(state.materialComp.updateErpMaterialLaoding) {
            dispatch("response/error-tip", {message: '同步中请勿重复同步！'});
            return
        }
        state.materialComp.updateErpMaterialLaoding = true;
        state.materialComp.updateErpMaterialMsg = [];
        let msg = { command: "update_client__erp_material", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
    },
    async ['fetch-list']({ state, dispatch, rootState,commit }, payload) {
        if(state.materialComp.loading) return;
        commit('setLoading',true);
        let msg = { command: "get_client__material_source_list", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
    },
    async ['return_list']({ state, commit }, payload) {
        commit('setLoading',false);
        if (payload.success) {
            if(!isNotEmpty(state.materialComp.pageConfigTree)){//生成 页面列配置 并处理成需要的结构
                let pageData = setPageConfig({pageData:payload.data.objs,tableName:state.materialComp.tableName,top_tools:state.materialComp.top_tools});
                commit('setPageConfig',pageData);
            }
            let myCoums = await getMyColums({name:state.materialComp.tableName+'-'+payload.data.obj});//获取偏好
            setNowTabPageCongfig({pageConfig:state.materialComp.pageConfig[payload.data.obj],myColums:myCoums})//设置为自己的偏好
            console.log(state.materialComp.pageConfig,'state.materialComp.pageConfig');
            commit('setList',payload.data);
        }
    },
    ['return_export']({ state, commit }, payload) {
        if(payload.success){
            window.open(process.env.VUE_APP_APIHOST+'/'+payload.data);
        }
    },
    async['export_excel']({ state, dispatch, rootState }, payload) {
        let msg = { command: "get_client__material_source_export_excel", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
        dispatch('response/info-tip', { message: '正在导出' }, { root: true })
    },
    async['return_inventory__export']({ state, dispatch, rootState }, payload) {
        if (payload.success) {
            window.open(payload.data, '_blank')
            dispatch('response/success-tip', { message: '导出成功' }, { root: true })
        }
    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}

